import { Button } from '@/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  startIndex: number
  endIndex: number
  totalItems: number
  onPageChange: (page: number) => void
}

export function Pagination({
  currentPage,
  totalPages,
  startIndex,
  endIndex,
  totalItems,
  onPageChange
}: PaginationProps) {
  if (totalItems === 0) return null

  const hasPagination = totalPages > 1
  const clampedChange = (page: number) => onPageChange(Math.max(1, Math.min(totalPages, page)))

  return (
    <div className="flex flex-col sm:flex-row items-center gap-3 sm:justify-end">
      <div className="text-sm text-muted-foreground">
        {hasPagination ? (
          <>
            Mostrando {startIndex + 1}-{Math.min(endIndex, totalItems)} de {totalItems}
          </>
        ) : (
          <>
            Mostrando {totalItems} item{totalItems === 1 ? '' : 's'}
          </>
        )}
      </div>

      {hasPagination && (
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => clampedChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <ChevronLeft className="h-4 w-4" />
            <span className="sr-only">Página anterior</span>
          </Button>

          <span className="text-sm font-medium">
            {currentPage} de {totalPages}
          </span>

          <Button
            variant="outline"
            size="sm"
            onClick={() => clampedChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <ChevronRight className="h-4 w-4" />
            <span className="sr-only">Próxima página</span>
          </Button>
        </div>
      )}
    </div>
  )
}
